import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { fadeInUp, staggerContainer, standardViewport } from '../../utils/animation';
import './ProcessSteps.scss';

const ProcessSteps = () => {
  const { t } = useTranslation('process');
  
  // Mapping imagini pentru pași (doar pașii care au imagini)
  const stepImages = {
    2: '/images/control-calitate.png',
    3: '/images/prelucrare-curatare.png',
    4: '/images/ambalare-etichetare.png',
    5: '/images/distributie.png'
  };
  
  const steps = [
    { number: 1, key: 'step1' },
    { number: 2, key: 'step2' },
    { number: 3, key: 'step3' },
    { number: 4, key: 'step4' },
    { number: 5, key: 'step5' }
  ];
  
  // Folosim animații centralizate pentru consistență

  return (
    <section className="process-steps">
      <div className="container">
        <motion.h2
          className="process-steps__title"
          initial="hidden"
          whileInView="visible"
          viewport={standardViewport}
          variants={fadeInUp}
        >
          {t('steps.title')}
        </motion.h2>
        <motion.p
          className="process-steps__intro"
          initial="hidden"
          whileInView="visible"
          viewport={standardViewport}
          variants={fadeInUp}
        >
          {t('steps.intro')}
        </motion.p>
        
        <div className="process-steps__container">
          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={standardViewport}
          >
            {steps.map((step) => {
              const stepData = t(`steps.${step.key}`, { returnObjects: true });
              const details = stepData.details || [];
              const hasImage = stepImages[step.number];
              const isEven = step.number % 2 === 0;
              
              return (
                <motion.div 
                  key={step.number} 
                  className={`process-steps__step ${hasImage ? 'process-steps__step--with-image' : ''} ${isEven ? 'process-steps__step--reverse' : ''}`}
                  variants={fadeInUp}
                >
                  <div className="process-steps__number">{step.number}</div>
                  <div className="process-steps__content">
                    <h3>{stepData.title}</h3>
                    <p>{stepData.description}</p>
                    <ul>
                      {details.map((detail, index) => (
                        <li key={index}>{detail}</li>
                      ))}
                    </ul>
                  </div>
                  {hasImage && (
                    <motion.div 
                      className="process-steps__image"
                      initial={{ opacity: 0, scale: 0.9 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      viewport={standardViewport}
                      transition={{ delay: 0.2, duration: 0.6 }}
                    >
                      <img src={stepImages[step.number]} alt={stepData.title} />
                    </motion.div>
                  )}
                </motion.div>
              );
            })}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;
